module.exports = __webpack_public_path__ + "img/Cover_FS_23.0c38a8df.jpg";